import "./css/menu.css";
import { Link, useNavigate } from "react-router-dom";
import { useState, useRef, useEffect } from "react";

const Menu = () => {
    // FIX: ब्रेकपॉइंट को 1000 से बढ़ाकर 1100 किया गया ताकि 1024px पर भी मेनू सही से मैनेज हो सके
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);
    const [showMainMenu, setShowMainMenu] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    
    const profileRef = useRef(null);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    // Authentication Check: Token exists but signtoken does not
    const token = localStorage.getItem("token");
    const signToken = localStorage.getItem("signtoken");
    const isAuthenticated = token && signToken === null;

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (profileRef.current && !profileRef.current.contains(e.target)) {
                setShowProfileMenu(false);
            }
            if (isMobile && menuRef.current && !menuRef.current.contains(e.target)) {
                setShowMainMenu(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, [isMobile]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1100);
            if (window.innerWidth > 1100) {
                setShowMainMenu(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        navigate("/");
        window.location.reload();
    };

    const handleLinkClick = () => {
        if (isMobile) setShowMainMenu(false);
        setShowProfileMenu(false);
    };

    const toggleMobileMenu = () => {
        setShowMainMenu(!showMainMenu);
        if (showProfileMenu) setShowProfileMenu(false);
    };

    const toggleProfileMenu = () => {
        setShowProfileMenu(!showProfileMenu);
    };

    return (
        <header className={`menuWrapper ${isScrolled ? 'scrolled' : ''}`} ref={menuRef}>
            <div className="menuContainer">
                
                {/* --- पहला DIV: Title/Logo और Mobile Toggle --- */}
                <div className="menuLogoContainer">
                    <Link to="/" className="menuLogo" onClick={handleLinkClick}>
                        <span className="logoText">
                            {process.env.REACT_APP_APP_NAME || "ExamWorld"}
                        </span>
                    </Link>

                    {isMobile && (
                        <div className="mobileMenuToggle" onClick={toggleMobileMenu}>
                            <div className={`hamburger ${showMainMenu ? 'active' : ''}`}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    )}
                </div>

                {/* --- दूसरा DIV: Main Menu (Nav Links + Profile/Auth) --- */}
                <div className={`menuMainMenuContainer ${showMainMenu ? 'active' : ''}`}>
                    
                    {/* नेविगेशन लिंक्स */}
                    <nav className="menuNav">
                        <ul className="navMenu">
                            <li><Link to="/" className="navLink" onClick={handleLinkClick}><span>Home</span></Link></li>
                            <li><Link to="/test" className="navLink" onClick={handleLinkClick}><span>Test</span></Link></li>
                            <li><Link to="/course" className="navLink" onClick={handleLinkClick}><span>Course</span></Link></li>
                            <li><Link to="/apply" className="navLink" onClick={handleLinkClick}><span>Apply</span></Link></li>
                            <li><Link to="/app" className="navLink" onClick={handleLinkClick}><span>App</span></Link></li>
                        </ul>
                    </nav>

                    {/* ऑथेंटिकेशन / प्रोफाइल */}
                    <div className="menuAuth" ref={profileRef}>
                        {isAuthenticated ? (
                            <div className="userProfile">
                                <div className="profileToggle" onClick={toggleProfileMenu}>
                                    <div className="profileAvatar">
                                        <span>U</span>
                                    </div>
                                    <span className="profileName">Profile</span>
                                    <span className="dropdownArrow">{showProfileMenu ? '▲' : '▼'}</span>
                                </div>
                                
                                {showProfileMenu && (
                                    <div className="profileDropdown">
                                        <div className="dropdownContent">
                                            <Link to="/profile" className="dropdownItem" onClick={handleLinkClick}>
                                                <span>My Profile</span>
                                            </Link>                                    
                                            <div className="dropdownDivider"></div>
                                            <button className="dropdownItem logoutButton" onClick={handleLogout}>
                                                <span>Logout</span>
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="authButtons">
                                <Link to="/login" className="authButton loginButton" onClick={handleLinkClick}>
                                    <span>Login</span>
                                </Link>
                                <Link to="/signup" className="authButton signupButton" onClick={handleLinkClick}>
                                    <span>Sign Up</span>
                                </Link>
                            </div>
                        )}
                    </div>

                </div>

            </div>
        </header>
    );
};

export default Menu;